angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherShareClass', function ($http, $log, EventManager, userAccount, api,  DATA_HOST, language) {
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope, element) {

      var eventManager = new EventManager('teacherShareClass', scope);

      scope.getTranslation = function(id){
        return language.get(id);
      }

    }
  }
});
